import { gql } from '@apollo/client';

export const JOBS_PAGE_QUERY = gql`
  query jobs_light(
    $limit: Int!
    $offset: Int!
    $q: String
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    jobs(
      limit: $limit
      offset: $offset
      q: $q
      isWeb: true
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      requestType
      reportNumber
      specialNotes
      staffDays
      windowStartAt
      windowEndAt
      auditStartAt
      auditEndAt
      internalAlertSubmittedAt
      clientAlertSentAt
      internalDraftCapSubmittedAt
      clientDraftCapSentAt
      reportSentForPreliminalQaAt
      reportSentForFinalQaAt
      clientFinalReportSentAt
      reportUploadedToClientPlatformAt
      downloadedAt
      auditRealStartAt
      auditRealFinishAt
      capGeneratedAt
      uploadedAt
      status
      reviewStartAt
      reviewEndAt
      reviewerId
      externalSaqStartAt
      externalSaqEndAt
      internalSaqStartAt
      internalSaqEndAt
      countryId
      jobAttachments {
        attachmentId
      }
      jobCompanies {
        id
        companyTypeId
        company {
          id
          currentVersion {
            id
            name
            companyTypes {
              id
            }
            companyAddresses {
              id
              currentVersion {
                countryId
              }
            }
          }
        }
      }
      jobServices {
        id
        service {
          id
          currentVersion {
            name
            description
            serviceType {
              type
            }
          }
        }
      }
      jobPrograms {
        id
        program {
          id
          currentVersion {
            name
            type
            defaultValue
            dropdownValues
          }
        }
      }
      jobAuditors {
        id
        staffDays
        isReportWriter
        user {
          id
          email
          firstName
          lastName
          login
        }
      }
    }
    jobsPageInfo(q: $q, isWeb: true, columnFilters: $columnFilters) {
      totalCount
    }
  }
`;

export const JOBS_QUERY = gql`
  query jobs_full(
    $limit: Int!
    $offset: Int!
    $q: String
    $columnFilters: [ColumnFilter!]
    $orderBy: String
    $orderDirection: String
  ) {
    jobs(
      limit: $limit
      offset: $offset
      q: $q
      columnFilters: $columnFilters
      orderBy: $orderBy
      orderDirection: $orderDirection
      isWeb: true
    ) {
      id
      requestType
      reportNumber
      specialNotes
      staffDays
      windowStartAt
      windowEndAt
      auditStartAt
      auditEndAt
      internalAlertSubmittedAt
      clientAlertSentAt
      internalDraftCapSubmittedAt
      clientDraftCapSentAt
      reportSentForPreliminalQaAt
      reportSentForFinalQaAt
      clientFinalReportSentAt
      reportUploadedToClientPlatformAt
      downloadedAt
      auditRealStartAt
      auditRealFinishAt
      capGeneratedAt
      uploadedAt
      status
      reviewStartAt
      reviewEndAt
      reviewerId
      countryId
      externalSaqStartAt
      externalSaqEndAt
      internalSaqStartAt
      internalSaqEndAt
      jobAttachments {
        attachmentId
      }
      jobCompanies {
        id
        companyTypeId
        company {
          id
          currentVersion {
            id
            name
            companyTypes {
              id
            }
            companyAddresses {
              id
              currentVersion {
                countryId
              }
            }
          }
        }
      }
      jobServices {
        id
        service {
          id
          currentVersion {
            name
            description
          }
        }
      }
      jobPrograms {
        id
        program {
          id
          currentVersion {
            name
            type
            defaultValue
            dropdownValues
          }
        }
      }
      jobAuditors {
        id
        staffDays
        isReportWriter
        user {
          id
          email
          firstName
          lastName
          login
        }
      }
      jobStakeholders {
        role
        user {
          id
          email
          firstName
          lastName
          login
        }
        userId
      }
    }
  }
`;

export const JOB_QUERY = gql`
  query job($id: Int!) {
    job(id: $id) {
      id
      requestType
      reportNumber
      specialNotes
      staffDays
      windowStartAt
      windowEndAt
      auditStartAt
      auditEndAt
      internalAlertSubmittedAt
      clientAlertSentAt
      internalDraftCapSubmittedAt
      clientDraftCapSentAt
      reportSentForPreliminalQaAt
      reportSentForFinalQaAt
      clientFinalReportSentAt
      reportUploadedToClientPlatformAt
      downloadedAt
      auditRealStartAt
      auditRealFinishAt
      capGeneratedAt
      capStartAt
      capEndAt
      capRequestAt
      capServiceTargetEndAt
      uploadedAt
      status
      reviewStartAt
      reviewEndAt
      reviewerId
      externalSaqStartAt
      externalSaqEndAt
      internalSaqStartAt
      internalSaqEndAt
      pdfAttachmentId
      htmlAttachmentId
      reportNames
      countryId
      overallCapStatus
      displayLoadingResults
      resultsLoadedAt
      clientId
      isNewCapProcess
      capSavedAt
      capSubmittedAt
      isNewSaqProcess
      isSaq
      jobCompletedAt
      saqSubmissionRequested
      capType
    }
  }
`;

export const JOB_SHORT_RELATION_QUERY = gql`
  query job($id: Int!) {
    job(id: $id) {
      id
      countryId
      jobAttachments {
        attachmentId
      }
      jobCompanies {
        companyTypeId
        company {
          id
          currentVersion {
            name
            annualRevenue
            businessRegistrationNumber
            code
            companyId
            companyTypes {
              id
              currentVersion {
                id
                name
                description
              }
            }
            preferredResultFamilyId
            preferredResultFamily {
              id
              currentVersion {
                code
                name
                resultFamilyOutcomes {
                  resultCategoryId
                  resultCategory {
                    id
                    currentVersion {
                      code
                      name
                    }
                  }
                  resultId
                  result {
                    id
                    currentVersion {
                      description
                      code
                    }
                  }
                }
              }
            }
            createdById
            dbaName
            description
            displayName
            dnbCompanyName
            dunsNumber
            id
            internalRefNumber
            localName
            logo
            mainEmail
            mainFaxLine
            mainPhoneLine
            naicsCode
            naicsDescription
            name
            parentCompanyId
            sicCode
            sicDescription
            tickerSymbol
            totalEmployees
            updatedById
            companyAddresses {
              id
              currentVersion {
                address1
                address2
                name
                city
                code
                countryId
                country {
                  id
                  currentVersion {
                    name
                  }
                }
                stateProvinceId
                id
                latitude
                longitude
                poZipCode
                addressTypeId
                version
              }
            }
            companyContacts {
              id
              currentVersion {
                assistantName
                assistantPhone
                businessUnitId
                companyContactId
                createdById
                departmentId
                directWorkPhone
                doNotCall
                emailOptOut
                fax
                firstName
                homePhone
                id
                lastName
                localFirstName
                localLastName
                localMiddleName
                mailingAddressLine1
                mailingAddressLine2
                mailingCountryId
                mailingPoZipCode
                mailingStateProvinceId
                middleName
                mobilePhone
                notes
                otherAddressLine1
                otherAddressLine2
                otherCity
                otherCountryId
                otherPhone
                otherPoZipCode
                otherStateProvinceId
                personalEmail
                preferredLanguageId
                receiveAbbreviatedReportPdf
                receiveArtifactsAsLinks
                receiveFinalReportPdf
                receiveInvoice
                receiveQuote
                salutation
                status
                suffix
                title
                updatedById
                version
                workEmail
              }
            }
          }
        }
      }
      jobServices {
        service {
          id
          currentVersion {
            description
            name
            serviceTypeId
            serviceType {
              id
              name
              description
              type
            }
            schemes {
              id
              name
            }
            checklists {
              id
              currentVersion {
                id
                name
              }
            }
            datasheets {
              id
              currentVersion {
                id
                name
              }
            }
          }
        }
      }
      jobPrograms {
        program {
          id
          currentVersion {
            name
            type
            defaultValue
            dropdownValues
          }
        }
      }
      jobAuditors {
        staffDays
        isReportWriter
        user {
          id
          email
          firstName
          lastName
          login
        }
      }
      jobStakeholders {
        role
        user {
          id
          email
          firstName
          lastName
          login
        }
        userId
      }
      overallCapStatus
    }
  }
`;

export const JOB_RELATION_QUERY = gql`
  query job($id: Int!) {
    job(id: $id) {
      id
      countryId
      jobAttachments {
        attachmentId
      }
      jobCompanies {
        companyTypeId
        company {
          id
          currentVersion {
            name
            annualRevenue
            businessRegistrationNumber
            code
            companyId
            companyTypes {
              id
              currentVersion {
                id
                name
                description
              }
            }
            preferredResultFamilyId
            preferredResultFamily {
              id
              currentVersion {
                name
                code
                resultFamilyOutcomes {
                  resultCategoryId
                  resultCategory {
                    id
                    currentVersion {
                      code
                      name
                    }
                  }
                  resultId
                  result {
                    id
                    currentVersion {
                      description
                      code
                    }
                  }
                }
              }
            }
            createdById
            dbaName
            description
            displayName
            dnbCompanyName
            dunsNumber
            id
            internalRefNumber
            localName
            logo
            mainEmail
            mainFaxLine
            mainPhoneLine
            naicsCode
            naicsDescription
            name
            parentCompanyId
            sicCode
            sicDescription
            tickerSymbol
            totalEmployees
            updatedById
            companyAddresses {
              id
              currentVersion {
                address1
                address2
                name
                city
                code
                countryId
                country {
                  id
                  currentVersion {
                    name
                  }
                  laws {
                    id
                    currentVersion {
                      legislationName
                      articleSecNo
                      legalCitation
                      legalReqSummary
                      internalGuidelineInterpretation
                    }
                  }
                }
                stateProvinceId
                id
                latitude
                longitude
                poZipCode
                addressTypeId
                version
              }
            }
            companyContacts {
              id
              currentVersion {
                assistantName
                assistantPhone
                businessUnitId
                companyContactId
                createdById
                departmentId
                directWorkPhone
                doNotCall
                emailOptOut
                fax
                firstName
                homePhone
                id
                lastName
                localFirstName
                localLastName
                localMiddleName
                mailingAddressLine1
                mailingAddressLine2
                mailingCountryId
                mailingPoZipCode
                mailingStateProvinceId
                middleName
                mobilePhone
                notes
                otherAddressLine1
                otherAddressLine2
                otherCity
                otherCountryId
                otherPhone
                otherPoZipCode
                otherStateProvinceId
                personalEmail
                preferredLanguageId
                receiveAbbreviatedReportPdf
                receiveArtifactsAsLinks
                receiveFinalReportPdf
                receiveInvoice
                receiveQuote
                salutation
                status
                suffix
                title
                updatedById
                version
                workEmail
              }
            }
          }
        }
      }
      jobServicesJson
      jobServices {
        service {
          id
          currentVersion {
            description
            name
            serviceTypeId
            serviceType {
              id
              name
              description
              type
            }
            schemes {
              id
              name
            }
            checklists {
              id
              currentVersion {
                id
                checklistSections {
                  id
                  name
                  isQuickActive
                  quickResultId
                  parentPosition
                  position
                  questions {
                    id
                    alerts {
                      negativeAlert
                      negativeSeverityId
                      resultFamilyOutcome {
                        resultId
                      }
                      resultFamilyOutcomeId
                    }
                    checklistQuestion {
                      id
                      currentVersion {
                        id
                        clientSpecificConfigurations {
                          id
                          companyId
                          description
                          guidance
                          text
                        }
                        description
                        guidance
                        negativeResultAlert
                        isWildCardQuestion
                        negativeResultSeverityId
                        nonCompliances {
                          id
                          description
                          laws {
                            id
                            currentVersion {
                              articleSecNo
                              internalGuidelineInterpretation
                              legalCitation
                              legalReqSummary
                              legislationName
                            }
                          }
                        }
                        text
                      }
                    }
                    checklistQuestionId
                    conditions {
                      id
                      action
                      checklistQuestionId
                      logicalOperator
                      position
                      resultId
                    }
                    position
                  }
                }
                clientSpecific
                companyId
                defaultResultFamily {
                  id
                  currentVersion {
                    name
                    code
                    result {
                      id
                      currentVersion {
                        code
                        description
                      }
                    }
                    resultFamilyOutcomes {
                      resultCategory {
                        id
                        currentVersion {
                          code
                          name
                        }
                      }
                      resultCategoryId
                      resultId
                    }
                  }
                }
                defaultResultFamilyId
                effectiveDate
                name
                serviceSchemeId
                hasLegalRequirements
                hasRecommendations
              }
            }
            datasheets {
              id
              currentVersion {
                id
                name
                effectiveDate
                languages {
                  id
                  name
                }
                datasheetSections {
                  id
                  name
                  position
                  parentPosition
                  questions {
                    id
                    position
                    datasheetQuestionId
                    datasheetQuestion {
                      id
                      currentVersion {
                        id
                        createdById
                        status
                        updatedById
                        version
                        text
                        questionType
                        descriptionAlias
                        descriptionExternal
                        numberSettings {
                          id
                          precision
                          removeDecimalLimitation
                        }
                        autofillSettings {
                          id
                          field
                        }
                        radioButtonSettings {
                          rows
                        }
                        relationSettings {
                          id
                          entity
                          entityItems
                          allowMultiSelect
                        }
                        fileSettings {
                          id
                          fileType
                          fileSize
                        }
                        dropdownSettings {
                          id
                          options {
                            definition
                            value
                          }
                          allowMultiSelect
                        }
                        dependentDropdownSettings {
                          id
                          dependsOn
                          allowMultiSelect
                          options {
                            definition
                            label
                            parent
                          }
                        }
                        smileyRatingSettings {
                          available
                          text
                        }
                        starRatingSettings{
                          id
                          numberOfStarsAvailable
                          rows
                        }
                        textSettings {
                          id
                          isTextarea
                          isMaximized
                        }
                        tableSettings {
                          id
                          columns {
                            number
                            name
                            type
                            precision
                            fileType
                            fileSize
                            currencies
                            currencyItems {
                              id
                              name
                              code
                              symbol
                            }
                            entity
                            entityItems
                            allowMultiSelect
                            options {
                              definition
                              value
                            }                                            
                            removeDecimalLimitation
                            dependsOn
                            dependentDropdownOptions {
                              definition
                              label
                              parent
                            }
                          }
                          enableMultipleRows
                          maximizeWidth
                          fixedValues {
                            columnName
                            value
                          }
                        }
                        currencySettings {
                          id
                          currencies
                          currencyItems {
                            id
                            name
                            code
                            symbol
                          }
                        }
                        translations {
                          id
                          languageId
                          text
                          descriptionAlias
                          options
                        }
                      }
                    }
                    conditions {
                      id
                      action
                      predicate
                      predicateAddition
                      value
                      rangeStart
                      rangeEnd
                      rowName
                      logicalOperator
                      position
                      datasheetQuestionId
                    }
                  }
                }
              }
            }
          }
        }
      }
      jobPrograms {
        program {
          id
          currentVersion {
            name
            type
            defaultValue
            dropdownValues
          }
        }
      }
      jobAuditors {
        staffDays
        isReportWriter
        user {
          id
          email
          firstName
          lastName
          login
        }
      }
      jobStakeholders {
        role
        user {
          id
          email
          firstName
          lastName
          login
        }
        userId
      }
      overallCapStatus
      isSaq
    }
  }
`;

export const JOB_EFFECTIVE_RELATION_QUERY = gql`
  query jobEffective($id: Int!, $base: Boolean) {
    jobEffective(id: $id, base: $base) {
      id
      countryId
      jobAttachments {
        attachmentId
      }
      jobAuditors {
        isReportWriter
        staffDays
        user {
          id
          email
          firstName
          lastName
          login
        }
      }
      jobCompanies {
        company {
          id
          currentVersion {
            id
            annualRevenue
            businessRegistrationNumber
            code
            companyAddresses {
              id
              currentVersion {
                id
                address1
                address2
                addressTypeId
                city
                code
                country {
                  id
                  currentVersion {
                    name
                  }
                  laws {
                    id
                    currentVersion {
                      id
                      articleSecNo
                      internalGuidelineInterpretation
                      legalCitation
                      legalReqSummary
                      legislationName
                    }
                  }
                }
                countryId
                latitude
                longitude
                name
                poZipCode
                stateProvinceId
                version
              }
            }
            companyContacts {
              id
              currentVersion {
                id
                assistantName
                assistantPhone
                businessUnitId
                companyContactId
                createdById
                departmentId
                directWorkPhone
                doNotCall
                emailOptOut
                fax
                firstName
                homePhone
                lastName
                localFirstName
                localLastName
                localMiddleName
                mailingAddressLine1
                mailingAddressLine2
                mailingCountryId
                mailingPoZipCode
                mailingStateProvinceId
                middleName
                mobilePhone
                notes
                otherAddressLine1
                otherAddressLine2
                otherCity
                otherCountryId
                otherPhone
                otherPoZipCode
                otherStateProvinceId
                personalEmail
                preferredLanguageId
                receiveAbbreviatedReportPdf
                receiveArtifactsAsLinks
                receiveFinalReportPdf
                receiveInvoice
                receiveQuote
                salutation
                status
                suffix
                title
                updatedById
                version
                workEmail
              }
            }
            companyId
            companyTypes {
              id
              currentVersion {
                id
                description
                name
              }
            }
            createdById
            dbaName
            description
            displayName
            dnbCompanyName
            dunsNumber
            internalRefNumber
            localName
            logo
            mainEmail
            mainFaxLine
            mainPhoneLine
            naicsCode
            naicsDescription
            name
            parentCompanyId
            preferredResultFamily {
              id
              currentVersion {
                code
                name
                resultFamilyOutcomes {
                  result {
                    id
                    currentVersion {
                      code
                      description
                    }
                  }
                  resultCategory {
                    id
                    currentVersion {
                      code
                      name
                    }
                  }
                  resultCategoryId
                  resultId
                }
              }
            }
            preferredResultFamilyId
            sicCode
            sicDescription
            tickerSymbol
            totalEmployees
            updatedById
          }
        }
        companyTypeId
      }
      jobPrograms {
        program {
          id
          currentVersion {
            defaultValue
            dropdownValues
            name
            type
          }
        }
      }
      jobServices {
        service {
          id
          assessmentName
          assessmentStandard
          currentVersion {
            attachmentsMeta {
                name
                size
                type
                attId
                filePath
            }
            checklists {
              id
              checklistVersions {
                id
                checklistSections {
                  id
                  checklistSectionIdAlias
                  isQuickActive
                  quickResultId
                  name
                  parentPosition
                  position
                  questions {
                    id
                    alerts {
                      negativeAlert
                      negativeSeverityId
                      resultFamilyOutcome {
                        result {
                          id
                          currentVersion {
                            code
                            description
                          }
                        }
                        resultId
                      }
                      resultFamilyOutcomeId
                    }
                    checklistQuestion {
                      id
                      currentVersion {
                        id
                        checklistQuestionIdAlias
                        clientSpecificConfigurations {
                          id
                          companyId
                          description
                          guidance
                          text
                          logicType
                        }
                        description
                        guidance
                        negativeResultAlert
                        isWildCardQuestion
                        negativeResultSeverityId
                        nonCompliances {
                          id
                          description
                          laws {
                            id
                          }
                        }
                        text
                      }
                    }
                    checklistQuestionId
                    checklistQuestionIdAlias
                    conditions {
                      id
                      action
                      checklistQuestionId
                      logicalOperator
                      position
                      resultId
                    }
                    position
                    resultFamily {
                      currentVersion {
                        resultFamilyOutcomes {
                          result {
                            id
                            currentVersion {
                              code
                              description
                            }
                          }
                          resultCategory {
                            id
                            currentVersion {
                              code
                              name
                            }
                          }
                          resultCategoryId
                          resultId
                        }
                      }
                    }
                    resultFamilyId
                  }
                }
                clientSpecific
                companyId
                customPanel {
                  id
                  currentVersion {
                    id
                    customPanelId
                    customPanelSections {
                      id
                      name
                      parentPosition
                      position
                      questions {
                        id
                        conditions {
                          id
                          action
                          datasheetQuestionId
                          logicalOperator
                          position
                          predicate
                          predicateAddition
                          rangeEnd
                          rangeStart
                          rowName
                          value
                        }
                        datasheetQuestion {
                          id
                          currentVersion {
                            id
                            autofillSettings {
                              id
                              field
                            }
                            createdById
                            currencySettings {
                              id
                              currencies
                              currencyItems {
                                id
                                code
                                name
                                symbol
                              }
                            }
                            descriptionAlias
                            descriptionExternal
                            dropdownSettings {
                              id
                              allowMultiSelect
                              options {
                                definition
                                value
                              }
                            }
                            dependentDropdownSettings {
                              id
                              dependsOn
                              allowMultiSelect
                              options {
                                definition
                                label
                                parent
                              }
                            }
                            fileSettings {
                              id
                              fileSize
                              fileType
                            }
                            numberSettings {
                              id
                              precision
                              removeDecimalLimitation
                            }
                            questionType
                            radioButtonSettings {
                              rows
                            }
                            relationSettings {
                              id
                              allowMultiSelect
                              entity
                              entityItems
                            }
                            smileyRatingSettings {
                              available
                              text
                            }
                            starRatingSettings{
                              id
                              numberOfStarsAvailable
                              rows
                            }
                            status
                            tableSettings {
                              id
                              columns {
                                allowMultiSelect
                                currencies
                                currencyItems {
                                  id
                                  code
                                  name
                                  symbol
                                }
                                entity
                                entityItems
                                fileSize
                                fileType
                                name
                                number
                                options {
                                  definition
                                  value
                                }
                                dependsOn
                                dependentDropdownOptions {
                                  definition
                                  label
                                  parent
                                }
                                precision
                                type
                              }
                              enableMultipleRows
                              fixedValues {
                                columnName
                                value
                              }
                              maximizeWidth
                            }
                            text
                            textSettings {
                              id
                              isMaximized
                              isTextarea
                            }
                            translations {
                              id
                              languageId
                              text
                              descriptionAlias
                              options
                            }
                            updatedById
                            version
                          }
                        }
                        datasheetQuestionId
                        position
                      }
                    }
                    effectiveDate
                    name
                    status
                  }
                }
                customPanelId
                defaultResultFamily {
                  id
                  currentVersion {
                    name
                    code
                    resultFamilyOutcomes {
                      result {
                        id
                        currentVersion {
                          code
                          description
                        }
                      }
                      resultCategory {
                        id
                        currentVersion {
                          code
                          name
                        }
                      }
                      resultCategoryId
                      resultId
                    }
                  }
                }
                defaultResultFamilyId
                effectiveDate
                name
                serviceSchemeId
                showToFactoryUser
                hasLegalRequirements
                hasRecommendations
              }
            }
            datasheets {
              id
              datasheetVersions {
                id
                languages {
                  id
                  name
                }
                datasheetSections {
                  id
                  name
                  parentPosition
                  position
                  questions {
                    id
                    questionNumber
                    conditions {
                      id
                      action
                      datasheetQuestionId
                      logicalOperator
                      position
                      predicate
                      predicateAddition
                      rangeEnd
                      rangeStart
                      rowName
                      value
                    }                    
                    validations {
                      rule
                      text
                      position
                    }
                    datasheetQuestion {
                      id
                      currentVersion {
                        id
                        autofillSettings {
                          id
                          field
                        }
                        createdById
                        currencySettings {
                          id
                          currencies
                          currencyItems {
                            id
                            code
                            name
                            symbol
                          }
                        }
                        descriptionAlias
                        descriptionExternal
                        dropdownSettings {
                          id
                          allowMultiSelect
                          options {
                            definition
                            value
                          }
                        }
                        dependentDropdownSettings {
                          id
                          dependsOn
                          allowMultiSelect
                          options {
                            definition
                            label
                            parent
                          }
                        }
                        fileSettings {
                          id
                          fileSize
                          fileType
                        }
                        numberSettings {
                          id
                          precision
                          removeDecimalLimitation
                        }
                        questionType
                        radioButtonSettings {
                          rows
                        }
                        relationSettings {
                          id
                          allowMultiSelect
                          entity
                          entityItems
                        }
                        smileyRatingSettings {
                          available
                          text
                        }
                        starRatingSettings{
                          id
                          numberOfStarsAvailable
                          rows
                        }
                        status
                        tableSettings {
                          id
                          columns {
                            allowMultiSelect
                            currencies
                            currencyItems {
                              id
                              code
                              name
                              symbol
                            }
                            entity
                            entityItems
                            fileSize
                            fileType
                            name
                            number
                            options {
                              definition
                              value
                            }
                          dependsOn
                          dependentDropdownOptions {
                            definition
                            label
                            parent
                          }
                            precision
                            type
                          }
                          enableMultipleRows
                          fixedValues {
                            columnName
                            value
                          }
                          maximizeWidth
                        }
                        text
                        textSettings {
                          id
                          isMaximized
                          isTextarea
                        }
                        translations {
                          id
                          languageId
                          text
                          descriptionAlias
                          options
                        }
                        updatedById
                        version
                      }
                    }
                    datasheetQuestionId
                    position
                  }
                }
                defaultResultFamily {
                  id
                  currentVersion {
                    code
                    name
                    resultFamilyOutcomes {
                      result {
                        id
                        currentVersion {
                          code
                          description
                        }
                      }
                      resultCategory {
                        id
                        currentVersion {
                          code
                          name
                        }
                      }
                      resultCategoryId
                      resultId
                    }
                  }
                }
                survey {
                  datasheetVersionId
                  jobId
                  surveyData {
                    id
                    dashboardLink
                    publicLink
                    endDate
                    prizeDrawUrl
                    numberOfResponses
                    questions {
                      id
                      datasheetQuestionId
                      text
                      descriptionAlias
                      questionType
                      questionNumber
                      conditions {
                        action
                        datasheetQuestionId
                        id
                        logicalOperator
                        position
                        predicate
                        predicateAddition
                        rangeEnd
                        rangeStart
                        rowName
                        value
                      }
                      validations {
                        rule
                        text
                      }
                      translations {
                        descriptionAlias
                        id
                        languageId
                        options
                        text
                      }
                      autofillSettings {
                        field
                        id
                      }
                      currencySettings {
                        currencies
                        currencyItems {
                          code
                          id
                          name
                          symbol
                        }
                        id
                      }
                      dependentDropdownSettings {
                        allowMultiSelect
                        dependsOn
                        id
                        options {
                          definition
                          label
                          parent
                        }
                      }
                      dropdownSettings {
                        allowMultiSelect
                        id
                        options{
                          definition
                          value
                        }
                      }
                      fileSettings {
                        fileSize
                        fileType
                        id
                        isJobTemplate
                      }
                      numberSettings {
                        id
                        precision
                        removeDecimalLimitation
                      }
                      relationSettings {
                        allowMultiSelect
                        entity
                        entityItems
                        id
                      }
                      smileyRatingSettings {
                        available
                        text
                      }
                      starRatingSettings{
                        id
                        numberOfStarsAvailable
                        rows
                      }
                      tableSettings {
                        columns {
                          allowMultiSelect
                          currencies
                          currencyItems {
                            code
                            id
                            name
                            symbol
                          }
                          entity
                          entityItems
                          fileSize
                          fileType
                          isMaximized
                          isTextarea
                          name
                          number
                          options {
                            definition
                            value
                          }
                          precision                                        
                          removeDecimalLimitation
                          type              
                          dependsOn
                          dependentDropdownOptions {
                            definition
                            label
                            parent
                          }
                        }
                        enableMultipleRows
                        fixedValues {
                          columnName
                          value
                        }
                        id
                        maximizeWidth
                      }
                      textSettings {
                        id
                        isMaximized
                        isTextarea
                      }
                      radioButtonSettings {
                        rows
                      }
                      pictureSettings {
                        allowMultiSelect
                        options {
                          label
                          fileId
                          fileUrl
                        }
                      }
                      voiceSettings {
                        allowMultiSelect
                        options {
                          label
                          fileId
                          fileUrl
                        }
                      }
                    }
                  }
                }
                defaultResultFamilyId
                effectiveDate
                name
                showToFactoryUser
                isSurvey
              }
            }
            description
            name
            schemes {
              id
              name
            }
            serviceType {
              id
              description
              name
              type
            }
            serviceTypeId
          }
        }
      }
      jobServicesJson
      jobStakeholders {
        role
        user {
          id
          email
          firstName
          lastName
          login
        }
        userId
      }
      tagsConfiguration {
        id
        currentVersion {
          name
          tagsConfigurationTags {
            id
            tagId
            requirement
          }
        }
      }
    }
  }
`;

export const DATASHEET_QUESTION_RESULT_QUERY = gql`
  query jobWithDatasheetQuestionResults($id: Int!) {
    jobWithDatasheetQuestionResults(id: $id) {
      id
      datasheetQuestionResults {
        id
        attachments {
          attachmentId
        }
        attachmentsMeta {
          attId
          filePath
          name
          size
          type
        }
        commentStatus
        externalAttachments {
          attachmentId
        }
        externalAttachmentsMeta {
          attId
          filePath
          name
          size
          type
        }
        comments
        datasheetId
        datasheetQuestionId
        datasheetVersion
        currentQuestionId
        result
        isPrefilled
        isAutofill
        showToFactoryUser
        validationResultId
      }
      overallCapStatus
    }
  }
`;

export const CHECKLIST_QUESTION_RESULT_QUERY = gql`
  query jobWithChecklistQuestionResults($id: Int!) {
    jobWithChecklistQuestionResults(id: $id) {
      id
      checklistQuestionResults {
        id
        attachments {
          attachmentId
        }
        attachmentsMeta {
          attId
          filePath
          name
          size
          type
        }
        checklistId
        checklistQuestionId
        checklistVersion
        currentQuestionId
        comments
        correctedDate
        correctiveActionTaken
        customPanelResults {
          id
          checklistQuestionResultId
          createdById
          currentQuestionId
          customPanelId
          customPanelVersionId
          datasheetQuestionId
          result
        }
        detailedFinding
        legalRequirements
        nonCompliances {
          id
          checklistQuestionResultId
          isHiddenInDraftCap
          detailedFinding
          law
          lawId
          legalRequirements
          nonComplianceId
          findingType
          recommendations
        }
        recommendations
        resultId
        showToFactoryUser
        isMissingResults
      }
    }
  }
`;

export const JOB_AUDITORS_QUERY = gql`
  query jobAuditors {
    jobAuditors {
      id
      firstName
      lastName
    }
  }
`;

export const JOB_ERSA_GENERATION_STATUS_QUERY = gql`
  query job($id: Int!) {
    job(id: $id) {
      id
      ersaGenerationStatus
    }
  }
`;

export const PAST_RESULTS_QUERY = gql`
  query pastResults (
      $limit: Int!
      $offset: Int!
      $orderBy: String
      $orderDirection: String
      $auditStartTo: DateTime
      $factoryId: Int
      $hasResults: Boolean
  ){
    jobs(
      limit: $limit
      offset: $offset
      isWeb: true
      orderBy: $orderBy
      orderDirection: $orderDirection
      auditStartTo: $auditStartTo
      factoryId: $factoryId
      hasResults: $hasResults
    ){
      id
      reportNumber
      jobServices {
        service {
          id
          currentVersion {
            name
            serviceType {
              type
            }
          }
        }
      }
      jobCompanies {
        companyTypeId
        company {
          id
          currentVersion {
            name
            companyTypes {
              id
            }
          }
        }
      }
      auditStartAt
      auditEndAt
    }
  }
`;

export const DATASHEET_QUESTION_RESULT_COMMENTS = gql`
  query datasheetQuestionResultComments ($limit: Int!, $offset: Int!, $datasheetQuestionResultId: Int!) {
    datasheetQuestionResultComments (datasheetQuestionResultId: $datasheetQuestionResultId, limit: $limit, offset: $offset) {
      id
      datasheetQuestionResultId
      comment
      createdAt
      updatedAt
      userName
      createdBy
      commentVisibleForExternalUser
    }
  }
`;
